var AC_List = {
  version: 1,
  url_base: "",
  whitelist: ["add", "delete_list", "delete", "edit", "field_add", "field_delete", "field_edit", "field_view", "list", "paginator", "view"]
};
module.exports = AC_List;